import { get } from 'lodash';

export interface ConnectionInformation {
    downlink: number,
    effectiveType: string,
    rtt: number,
    saveData: boolean
}

export default class DeviceProvider {

    public static get connection(): ConnectionInformation | undefined {
        return get(navigator, 'connection') as unknown as ConnectionInformation ||
            get(navigator, 'mozConnection') as ConnectionInformation ||
            get(navigator, 'webkitConnection') as ConnectionInformation ||
            {
                downlink: 'unsupported',
                effectiveType: 'unsupported',
                rtt: 'unsupported',
                saveData: 'unsupported'
            };
    }
}
